<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" title="智慧交通-经典案例" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
          <img v-lazy="cas.Img" />
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.Title}}</p>
            <p class="abstract-content">{{cas.Content}}</p>
            <!-- <div class="more">
              <router-link
                class="text-decoration"
                :to="{ name: 'case', params: { id: cas.Id }}"
              >
                <span>more</span>
                <img src="../assets/img/sanjiao.png" />
              </router-link>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
      caseList: [{
		Img:'https://file.jxth.com.cn/group1/M02/00/25/dSm0ymDAYWeAe9vyABbQ2id7cZw247.png',
		Title:'井冈山G356龙市至睦村、S541龙市至茨坪段“畅、安、舒、美”科技示范路工程',
		Content:'本工程为井冈山S541龙茨线，起点与G356交叉处桩号为K0+000，途经葛田、大陇镇、茅坪和黄洋界，终于茨坪桩号为K46+206，全长46.206km。本项目路段急弯、连续弯、陡坡弯和180°弯多达76处和4处长坡，尤其是S541黄洋界岔道口~茨坪段，陡坡弯和180°弯等事故多发路段最为突出。由我司承建“畅、安、舒、美”示范路工程智能交通部分，包含弯道会车监测及预警系统设备16套、长坡会车监测及预警系统设备1套、综合气象监测及预警设备2套、定制综合数据分析及控制预警软件系统。2020年11月13日，井冈山G356龙市至睦村、S541龙市至茨坪段“畅、安、舒、美”示范路工程顺利通过国检。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M00/00/25/dSm0ymDAXemAZB3QAAs5BcMKB4Q154.png',
		Title:'荣乌高速公路新线京台高速至京港澳高速段机电工程监理项目',
		Content:'2021年5月29日上午，由通慧科技集团参与工程监理的河北荣乌高速公路新线如期建成通车，标志着雄安新区对外骨干路网初步建成通车。本次同步开通京雄高速公路（河北段）、荣乌高速新线、京德高速公路（一期工程），宣告河北省高速公路通车里程突破8000公里。荣乌高速新线是雄安新区通往天津港、黄骅港集疏运体系的主要通道，全长72.814公里，全线采用双向八车道高速公路标准建设，替代原荣乌高速公路穿越雄安新区段的功能和作用，成为京南雄北的货运主通道，为以后外地大货车绕行雄安新区提供支撑。助力京津冀交通一体化，承担着为京津冀与河北“两翼”的协同发展构筑新循环的使命。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M01/00/25/dSm0ymDAXrmAZ3y_AAXMs7__StE092.png',
		Title:'江西省高速公路分布式光伏发电项目',
		Content:'全国首例高速公路分布式光伏发电项目。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M02/00/25/dSm0ymDAZgCAQ2OEAAxaLdad-Cc701.png',
		Title:'绥芬河至满洲里国家高速公路海拉尔至满洲里段公路工程机电项目',
		Content:'本项目的建设包含主线、连接线及辅道。主线采用双向四车道高速公路标准建设，设计速度 100km/h，改建段路基宽度整体式断面采用 24m，分离式路基采用单幅 12m，新建段采用整体式 26m，全长 188.9km。为了实现 G331 线贯通，以及黑山头口岸和岐岗火车站交通之间的交通转换，本项目设嵯岗连接线一处，全长 30.4Km，其中，新建三级公路连接线 26.1 公里，利用辅道 4.3 公里。设计速度 40 Km/h，路基宽度 8.5m。考虑现有一级公路改造成高速公路封闭后沿线群众的出行需求和车辆运输的需要，沿主线设置辅道，全长 225.9Km。'
	  },{
		Img:'https://file.jxth.com.cn/group1/M00/00/25/dSm0ymDAZqKAcyXUAAkaC8nZp70878.png',
		Title:'金赣服务中心2#智能化工程',
		Content:'本项目主要包括：机房工程、IBMS系统集成综合管理平台、楼宇设备自控系统、能耗计量及检测系统、停车场管理系统、五方对讲、智能照明系统、综合布线系统等。'
	  }]
    };
  },
  mounted() {
	  
  }
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 450px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 360px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 200px;
			line-height: 1.5;
            color: #484848;
            font-size: 15px;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // display: -webkit-box;
            // -webkit-line-clamp: 18;
            // -webkit-box-orient: vertical;
            // white-space: normal !important;
            // word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>